import React from "react";
import { Link, useLocation } from "react-router-dom";
import { MapPinIcon, MenuSquareIcon, PhoneIcon, ShoppingBagIcon } from "lucide-react";
import { locations } from "../data/locations";
import { useSite } from "../context/SiteContext";
export function MobileActionBar() {
  const {
    selectedLocation,
    t
  } = useSite();
  const {
    pathname
  } = useLocation();
  const routeLocation = pathname === "/victor" || pathname === "/menus/victor" ? "victor" : pathname === "/driggs" || pathname === "/menus/driggs" ? "driggs" : selectedLocation;
  const location = locations[routeLocation];
  const actions = [{
    label: t("Menu", "Menú"),
    icon: MenuSquareIcon,
    to: location.menuPath
  }, {
    label: t("Order info", "Cómo ordenar"),
    icon: ShoppingBagIcon,
    to: location.menuPath
  }, {
    label: t("Call", "Llamar"),
    icon: PhoneIcon,
    href: location.phoneHref
  }, {
    label: t("Directions", "Cómo llegar"),
    icon: MapPinIcon,
    href: location.directionsUrl
  }];
  return <nav className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-4 border-t border-sand/30 bg-ivory/95 px-2 pb-[max(8px,env(safe-area-inset-bottom))] pt-2 shadow-[0_-8px_30px_rgba(0,0,0,.1)] backdrop-blur md:hidden" aria-label="Quick actions" data-id="element-151" data-mp="34hk8m8x8qwec">{actions.map(({
      label,
      icon: Icon,
      to,
      href
    }) => to ? <Link key={label} to={to} className="flex min-h-14 flex-col items-center justify-center gap-1 rounded-lg text-[10px] font-bold text-cocoa hover:text-terracotta focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-152" data-mp="15pg0dfx96ctu"><Icon className="h-5 w-5" data-id="element-153" data-mp="qujjkebdoh55" />{label}</Link> : <a key={label} href={href} className="flex min-h-14 flex-col items-center justify-center gap-1 rounded-lg text-[10px] font-bold text-cocoa hover:text-terracotta focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-154" data-mp="qsqbqvp13qvk"><Icon className="h-5 w-5" data-id="element-155" data-mp="hvy790wi1yct" />{label}</a>)}</nav>;
}